import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

export const useSyncedParamValue = (
  param: string
): [string | null, (v: string | null) => void] => {
  const [values, setValues] = useSyncedParamValues(param);
  return [
    values.length ? values[0] : null,
    (v: string | null) => setValues(v ? [v] : []),
  ];
};

export const useSyncedParamValues = (
  param: string
): [string[], (v: string[]) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [values, _setValues] = useState<string[]>(searchParams.getAll(param));
  useEffect(() => {
    _setValues(searchParams.getAll(param));
  }, [searchParams]);

  const setValues = (newValues: string[]) => {
    _setValues(newValues);
    setSearchParams((prev) => {
      prev.delete("page"); // changing a filter value always resets page number
      prev.delete(param);
      newValues.forEach((v) => prev.append(param, v));
      return prev;
    });
  };

  return [values, setValues];
};
